import { UseQueryResult } from '@tanstack/react-query';
import { ProjectDto } from 'services/api/api-client.types.ts';
import { useHandleQueryError } from '../../helpers/error-helpers.ts';
import { Links } from '../../application/constants/links.ts';
import { useModal } from '../uikit/modal/useModal.tsx';
import { useNavigate } from 'react-router';
import { useScopedTranslation } from '../../application/localization/useScopedTranslation.ts';
import { useCallback } from 'react';
import { QueryFactory } from '../../services/api/index.ts';
import { showErrorToast } from 'components/uikit/toast/showToast';

type UseHandleProjectAccessDeniedProps = {
  projectQuery: UseQueryResult<ProjectDto, any>;
  projectId?: number;
};

export const useHandleProjectAccessDenied = (
  props: UseHandleProjectAccessDeniedProps,
) => {
  const i18n = useScopedTranslation('Component.AccessDeniedModal');
  const navigate = useNavigate();
  const modal = useModal();

  const handler = useCallback(async () => {
    navigate(Links.Authorized.Projects.link(), { replace: true });

    const result = await modal.showConfirm({
      title: i18n.t('title'),
      text: i18n.t('text'),
      okButtonText: i18n.t('buttons.request'),
      cancelButtonText: i18n.t('buttons.cancel'),
    });
    if (!result || !props.projectId) return;

    try {
      await QueryFactory.ProjectTeamClient.requestAccess(props.projectId);
    } catch (e) {
      showErrorToast(e);
    }
  }, [navigate, modal, i18n]);

  useHandleQueryError(props.projectQuery, handler, 403);
};
